export const TABLE_HEAD_EXISTING = [
  { id: "strategy", label: "Strategy", alignCenter: true },
  { id: "realPosition", label: "Real Custodian", alignCenter: true },
  { id: "crossingPosition", label: "Cros Custodian", alignCenter: true },
  { id: "totalPosition", label: "Net Position", alignCenter: true },
];
export const TABLE_HEAD_TARGET = [
  { id: "strategy", label: "Strategy", alignCenter: true },
  { id: "existingNet", label: "Existing", alignCenter: true },
  { id: "order", label: "SingleLine Order", alignCenter: true },
  { id: "target", label: "Target", alignCenter: true },
];
export const TABLE_HEAD_ORDER = [
  { id: "Pstrategy", label: "Strategy", alignCenter: true },
  { id: "shareCount", label: "Amount", alignCenter: true },
  { id: "tradeType", label: "Action-Position", alignCenter: true },
  { id: "custodian", label: "Custodian", alignCenter: true },
  { id: "broker", label: "Broker", alignCenter: true },
];
export const TABLE_HEAD_AFTERORDERS = [
  { id: "strategy", label: "Strategy", alignCenter: true },
  { id: "starting", label: "Existing", alignCenter: true },
  { id: "orders", label: "Generated Orders", alignCenter: true },
  { id: "ending", label: "Final Position", alignCenter: true },
];
